interface IConfigReturn {
  GIT_HASH: string
}

export const Config = (): IConfigReturn => ({
  GIT_HASH: process.env.REACT_APP_GIT_HASH || '',
})
